import { ModalContextProvider } from 'utils/contexts/modal';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';
import { ExpansionContextProvider } from 'utils/contexts/expansion';
import { QueryErrorStateContextProvider } from 'modules/queryBuilder/contexts/queryErrorState';
import { useTranslation as useQueryBuilderTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { PageHeader } from './components/pageHeader';
import { SegmentationResults } from './components/segmentationResults/SegmentationResults';
import { SegmentationModals } from './components/modals/SegmentationModals';
import { SegmentationPageLoader } from './components/SegmentationPageLoader';
import { QueryBuilderSection } from './components/queryBuilderSection/QueryBuilderSection';
import { FacebookAdAccountsProvider } from './contexts/facebookAdAccounts';
import { ListDetailsContextProvider, useListDetailsContext } from './contexts/listDetails';
import { ListReferencesContextProvider } from './contexts/listReferences';
import { MatchesCatalogContextProvider } from './contexts/matchesCatalog';
import { PermissionsContextProvider } from './contexts/permissions';
import { SegmentationQueryContextProvider } from './contexts/segmentationQuery';
import { UserFieldsContextProvider } from './contexts/userFields';
import { UsersTableContextProvider } from './contexts/usersTable';
import { useTranslation as useSegmentationPageTranslation } from './hooks';
import { SegmentationPageContainer } from './SegmentationPage.styles';

export const testIds = {
  segmentationPage: 'segmentation-page',
};

const SegmentationPageContent = () => {
  const navBarHeight = useNavBarHeight();
  const { isLoading: isLoadingListDetails } = useListDetailsContext();
  const { ready } = useSegmentationPageTranslation();
  const { ready: queryBuilderTranslationReady } = useQueryBuilderTranslation();

  if (!ready || !queryBuilderTranslationReady || isLoadingListDetails) {
    return <SegmentationPageLoader />;
  }

  return (
    <SegmentationPageContainer data-test={testIds.segmentationPage} navBarHeight={navBarHeight}>
      <PageHeader />
      <SegmentationModals />
      <QueryBuilderSection />
      <SegmentationResults />
    </SegmentationPageContainer>
  );
};

export const SegmentationPage = () => (
  <FacebookAdAccountsProvider>
    <PermissionsContextProvider>
      <UserFieldsContextProvider>
        <ListDetailsContextProvider>
          <UsersTableContextProvider>
            <MatchesCatalogContextProvider>
              <QueryErrorStateContextProvider>
                <SegmentationQueryContextProvider>
                  <ModalContextProvider>
                    <ExpansionContextProvider>
                      <ListReferencesContextProvider>
                        <SegmentationPageContent />
                      </ListReferencesContextProvider>
                    </ExpansionContextProvider>
                  </ModalContextProvider>
                </SegmentationQueryContextProvider>
              </QueryErrorStateContextProvider>
            </MatchesCatalogContextProvider>
          </UsersTableContextProvider>
        </ListDetailsContextProvider>
      </UserFieldsContextProvider>
    </PermissionsContextProvider>
  </FacebookAdAccountsProvider>
);
